import { useEffect } from "react";
import type { SWRConfiguration } from "swr";
import useSWR from "swr";
import { TResume, useResumeStore } from "../store/resume";

const fetcher = (url: string | URL | Request) =>
  fetch(url).then((res) => res.json());

export default function useResume(id: String, options: SWRConfiguration) {
  const { data, error, isLoading } = useSWR<TResume>(
    `/api/resumes/${id}`,
    fetcher,
    options,
  );

  const { setResume } = useResumeStore();

  useEffect(() => {
    if (!data) return;
    setResume(data);
  }, [setResume, data]);

  return {
    resume: data,
    error,
    isLoading,
  };
}
